import React, { useState, useContext } from "react";
import { useNavigate, Link } from "react-router-dom";
import { useToasts } from "react-toast-notifications";
import { GlobalContext } from "../contexts";
import { firebaseErrorMap } from "../config";
import { Grid, Image, Button } from "semantic-ui-react";
import {
  getAuth,
  signOut,
  createUserWithEmailAndPassword,
  signInWithEmailAndPassword,
  sendPasswordResetEmail,
  sendEmailVerification,
} from "firebase/auth";

function Register() {
  let navigate = useNavigate();
  const { addToast } = useToasts();

  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");
  const [loading, setLoading] = useState(false);

  const handleChange = (event, callback) => {
    callback(event.target.value);
  };

  const resetPassword = async (e) => {
    e.stopPropagation();
    e.preventDefault();
    if (loading) {
      return;
    }
    setLoading(true);
    try {
      await sendPasswordResetEmail(getAuth(), email);
      addToast("An email to reset password has been sent to you!", {
        appearance: "success",
        autoDismiss: true,
      });
      setMessage("");
    } catch (e) {
      const message = firebaseErrorMap[e.code] || e.message;
      setMessage(message);
    }
    setLoading(false);
  };

  return (
    <div className="container password">
      <h1>Forgot password?</h1>
      <form className="form">
        <input
          type="text"
          onChange={(e) => handleChange(e, setEmail)}
          placeholder="Email"
        />
        <Button
          disabled={loading}
          loading={loading}
          type="submit"
          id="login-button"
          onClick={resetPassword}
        >
          Reset Now
        </Button>
        <div className="response-message">{message}</div>
        <Grid columns={4} divided centered>
          <Grid.Row>
            <Grid.Column style={{display: 'flex', justifyContent: 'center'}}>
              <Link
                href="#"
                to="/login"
                style={{ color: "white", fontWeight: "bold" }}
              >
                Login
              </Link>
            </Grid.Column>
            <Grid.Column  style={{display: 'flex', justifyContent: 'center'}}>
              <Link
                href="#"
                to="/register"
                style={{ color: "white", fontWeight: "bold" }}
              >
                Register
              </Link>
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </form>
    </div>
  );
}
export default Register;
